import { BASE_URL_REGEX } from '../constants/constants';
import { t } from 'i18next';

export function formatTime(totalSeconds: number): string {
	const minutes: number = Math.floor(totalSeconds / 60);
	const seconds: number = totalSeconds % 60;
	return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
}

export function getCompleteUrl(base?: string): string {
	if (!base) return '';
	let url: string = base;
	if (!BASE_URL_REGEX.test(base)) {
		url = 'http://' + base;
	}
	return url;
}

export function getSimpleUrl(base?: string): string {
	if (!base) return '';
    let url: string = base;
    if (BASE_URL_REGEX.test(base)) {
        url = base.replace('https://', '').replace('http://', '');
    }
    return url;
}

export function period(element: any): string {
	return zeroPad(element.startMonth, 2) + '/' + element.startYear + ' - ' +
		(element.endMonth
			? zeroPad(element.endMonth, 2) + '/' + element.endYear
			: t('form.not-completed'));
}

export function zeroPad(num: number, places?: number): string {
    return String(num).padStart(places ?? 0, '0');
}

export function isNullOrEmpty(input?: string | boolean | number | Date): boolean {
	return input === null || input === undefined || input === '';
}

export function isNotNullOrEmpty(input?: string | boolean | number | Date): boolean {
    return !isNullOrEmpty(input);
}

export function isNullOrFalse(input?: boolean): boolean {
    return input === null || input === undefined || !input;
}

export function isNotNullOrFalse(input?: boolean): boolean {
    return !isNullOrFalse(input);
}

export function titleCase(input?: string): string | undefined {
	if (!input) return undefined;
	return input
		.toLowerCase()
		.split(' ')
		.map((word: string): string => word.charAt(0).toUpperCase() + word.slice(1))
		.join(' ');
}
